import { connect } from 'react-redux';
import Favorite from './favorite';
import { add, remove, load } from '../../actions/favorites';
import { fetchFavorites } from '../../selectors/favorite';

const mapStateToProps = (state, props) => fetchFavorites(state, props);

export default connect(mapStateToProps, { add, remove, load })(Favorite);
